
export default {
  name: 'TransactionSuccessToast',
  props: {
    msg: { type: String, default: 'Success!' },
  },
};
